import { render, staticRenderFns } from "./sorterMethodologyParts.vue?vue&type=template&id=aa7463ec&scoped=true"
import script from "./sorterMethodologyParts.vue?vue&type=script&lang=js"
export * from "./sorterMethodologyParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7463ec",
  null
  
)

export default component.exports